module.exports = __webpack_public_path__ + "static/media/dramaImg2.bb7a793e.jpg";